export const MANAGE_ORGANIZATION_AREA = 'ManageOrganization';
